import Input from '@/components/atoms/input';
import { MAX_MEMO_LENGTH } from '@/consts';
import * as ViewModel from '@/core/presenter/viewModel';

interface IProps {
  defaultMemo: string;
  isWritting: boolean;
  onChangeMemo: (e: React.SyntheticEvent<HTMLInputElement>) => void;
}

const SendInputMemo = ({ defaultMemo, isWritting, onChangeMemo }: IProps) => {
  return (
    isWritting && (
      <div className="memo-area">
        <p className="label">이 주소에 대한 메모</p>
        <Input
          type="text"
          id="memoInput"
          placeholder="메모 입력"
          validatorType={ViewModel.InputValidatorType.ALLOW_ALL}
          value={defaultMemo}
          maxLength={MAX_MEMO_LENGTH}
          onChange={onChangeMemo}
          onClick={() => {}}
        />
      </div>
    )
  );
};

export default SendInputMemo;
